<footer class="px-3 px-md-5 pt-5 pb-4">
  <div class="row align-items-start mb-4 gy-4">
    <div class="col-12 col-md-6 col-lg-3 mb-3 mb-md-0 pe-4">
      <div class="d-flex justify-content-center justify-content-lg-start align-items-center mb-5">
        <img
          src="/images/logo-full-white.svg"
          alt="Q Mobility Logo"
          width="220"
          height="32"
          class="me-2"
        />
      </div>
      <h6 class="mb-0 pe-0 pe-md-5 text-center text-md-start" style="color: var(--text-color)">
        Experience the ease and convenience of renting a car with Qmobility.
      </h6>
    </div>
    <div class="col-6 col-md-6 col-lg-3 mb-3 mb-md-0">
      <h5 class="ff-poppins-semibold mb-4">Legal Policy</h5>
      <ul class="list-unstyled">
        <li class="mb-2">
          <a class="text-decoration-none" href="javascript:void(0)" (click)="onTermsAndConditions()"
            >Term &amp; Condition</a
          >
        </li>
        <li class="mb-2">
          <a class="text-decoration-none" href="javascript:void(0)" (click)="onPrivacyPolicy()"
            >Privacy Policy</a
          >
        </li>
      </ul>
    </div>
    <div class="col-6 col-md-6 col-lg-3 mb-3 mb-md-0">
      <h5 class="ff-poppins-semibold mb-4">Quick Links</h5>
      <ul class="list-unstyled">
        <li>
          <a class="text-decoration-none" href="/#about-us" routerLink="/" fragment="about-us"
            >About Us</a
          >
        </li>
        <li>
          <a class="text-decoration-none" href="javascript:void(0)" (click)="onContactUs()"
            >Contact</a
          >
        </li>
      </ul>
    </div>
    <div class="col-12 col-md-6 col-lg-3 d-flex flex-column align-items-center">
      <h5 class="ff-poppins-semibold mb-4 text-center text-md-start">
        Subscribe To The Newsletter
      </h5>
      <form
        class="newsletter-form d-flex align-items-center bg-light rounded-pill px-2 py-1"
        [formGroup]="form"
      >
        <input
          type="email"
          class="form-control border-0 bg-light rounded-pill me-2"
          placeholder="Email..."
          aria-label="Email address"
          style="box-shadow: none"
          formControlName="email"
        />
        <button
          type="button"
          mat-icon-button
          class="btn-icon"
          (click)="onSubmit()"
          [ngClass]="{ disabled: form.invalid }"
        >
          <img src="/icons/ic_arrow_upword.svg" alt="Subscribe" width="20" />
        </button>
      </form>
    </div>
  </div>
  <div
    class="d-flex flex-column flex-md-row justify-content-center justify-content-md-between align-items-center border-top pt-4 mt-3"
  >
    <h6 class="text-center text-md-start mb-3 mb-md-0">
      &copy; {{ currentYear }} Q mobility car rental. All rights reserved.
    </h6>
    <div class="d-flex justify-content-center justify-content-md-start gap-3 me-5">
      <a href="#" target="_blank" rel="nofollow noopener" aria-label="YouTube"
        ><img src="/icons/ic_youtube.svg" alt="YouTube" width="25px" height="25px"
      /></a>
      <a href="#" target="_blank" rel="nofollow noopener" aria-label="Facebook"
        ><img src="/icons/ic_facebook.svg" alt="Facebook" width="25px" height="25px"
      /></a>
      <a href="#" target="_blank" rel="nofollow noopener" aria-label="Instagram"
        ><img src="/icons/ic_insta.svg" alt="Instagram" width="25px" height="25px"
      /></a>
      <a href="#" target="_blank" rel="nofollow noopener" aria-label="LinkedIn"
        ><img src="/icons/ic_linkedin.svg" alt="LinkedIn" width="25px" height="25px"
      /></a>
    </div>
  </div>
</footer>
